export const CONFIG = {
  NEED_SIGNOUT: 'NEED_SIGNOUT',
  PICKUP_LOCATION: 'PICKUP',
  UPTIME_HARDWARE_MANAGEMENT: {
    KEY: 'UPTIME_HARDWARE_MANAGEMENT',
    LABEL: 'UPTIME_GENERAL_CONFIG'
  },
  UPTIME_PCL_SETTING: {
    KEY: 'UPTIME_PCL_SETTING',
    LABEL: 'UPTIME_GENERAL_CONFIG'
  },
  PERMISSION: {
    KEY: 'UPTIME_PERMISSION',
    LABEL: 'PERMISSION_CONFIG',
  },
  PERMISSION_ABO: {
    KEY: 'UPTIME_PERMISSION_ABO',
    LABEL: 'PERMISSION_CONFIG',
  },
  IC_APPS: {
    KEY: 'UPTIME_IC_APPS',
    LABEL: 'IC_APPS_CONFIG',
  },
  PERMISSION_KEY: {
    PC_MANAGEMENT: 'pcManagement',
    REQUEST_TYPES: 'requestTypes',
    KNOWLEDGE: 'knowledge',
    SERVICE_CATALOG: 'serviceCatalog',
    DASHBOARD: 'dashboard',
    IC_SERVICE_REQUEST: 'icServiceRequest',
    AUTOMATED_SERVICE_REQUEST: 'automatedServiceRequest'
  },
  PC_MANAGEMENT: {
    MY_TECHNOLOGY: 'myTechnology',
    CARD_TRACKER: 'cardTracker',
    PC_LIFECYCLE: 'pcLifecycle',
    ORDER_NEW_DEVICE: 'orderNewDevice',
    CAN_REFRESH: 'canRefresh',
    CAN_RETURN: 'canReturn',
    CAN_REPORT_BROKEN: 'canReportBroken',
    CAN_REPORT_OWNERSHIP_ERROR: 'canReportOwnershipError',
    CAN_REGISTER_OWNERSHIP: 'canRegisterOwnership',
    CAN_REPORT_MISSING: 'canReportMissing',
    I_DONT_SEE_MY_DEVICE: 'iDontSeeMyDevice',
    RETURN_UNKNOWN_DEVICE: 'returnUnknownDevice',
    REQUEST_VM: 'requestVirtualMachine',
    CANCEL_WORKFLOW: 'cancelWorkflow',
    SHOW_PRIMARY_LABEL: 'showPrimaryLabel',
    SHOW_SERIAL_NUMBER: 'showSerialNumber',
    SHOW_LAST_SCANNED: 'showLastScanned',
    SHOW_ASSIGNED: 'showAssigned',
    MARKET_PLACE: 'marketPlace',
    ANALYTICS_CONFIG: 'analytics',
    REQUEST_VA: 'requestVirtualApp',
    ACT_ON_BEHALF_OF: 'actOnBeHalfOf',
    MANAGE: 'manage',
    SUBMIT_WITHOUT_DEVICE: 'canSubmitWithoutDevice',
    TACHYON: 'tachyon',
    HAS_DEVICE_ID_PARAM: 'hasDeviceIdParam',
    PERSONAL_EMAIL: 'personalEmail',
    RETURN_REASON: 'returnReason',
    EXCEPTION_REQUEST: 'exceptionRequest',
  },
  USER_PREFERENCE: {
    LANGUAGE: 'language',
    MEASUREMENT: 'measurement',
  },
  SMALL_CARD_DIRECT_LINK: {
    DXC_GEAR: 'dxcGear',
    YOUR_SOFTWARE: 'yourSoftware',
    M365_SERVICES: 'm365Services',
    MS_TEAMS_OWNED: 'MsTeamsOwned',
  },
  QUICK_LINKS: {
    YOUR_GEAR: 'yourGear',
    YOUR_SOFTWARE: 'yourSoftware',
    M365_SERVICES: 'm365',
    MS_TEAMS_OWNED: 'teamsOwned',
  },
  PILOT_CONFIG: {
    CONTENT: {
      KEY: 'UPTIME_PILOT_CONTENT',
      LABEL: 'UPTIME_STATIC_PAGE_CONFIG',
    },
  },
  VIRTUAL_MACHINE: {
    KEY: 'VIRTUAL_MACHINE_LIST',
    LABEL: 'VIRTUAL_MACHINE_CONFIG',
  },
  VIRTUAL_APP: {
    KEY: 'VIRTUAL_APP_LIST',
    LABEL: 'VIRTUAL_APP_CONFIG',
  },
  CUSTOM_THEME: {
    KEY: 'CUSTOMER_THEME',
    LABEL: 'CUSTOMER_THEME',
  },
  KNOWLEDGE_DETAIL: {
    USEFUL: 'useful',
    RATING: 'rating',
    COMMENT: 'comment',
    LIKE_COMMENT: 'likeComment',
    REPLY_COMMENT: 'replyComment',
    EDIT_COMMENT: 'editComment',
    DELETE_COMMENT: 'deleteComment',
    RELATED_ARTICLES: 'relatedArticles',
    USER_COMMENTS: 'userComments',
    ATTACHMENTS: 'attachments'
  },
  KNOWLEDGE: {
    KNOWLEDGE_DETAIL: 'knowledgeDetail',
    SEARCH: 'search',
    TOP_KNOWLEDGE_ARTICLES: 'topKnowledgeArticles',
    OUTAGES: 'outages',
    ANNOUNCEMENTS: 'announcements',
    OUTAGE_LIST: 'outageList',
    MAJOR_OUTAGE_LIST: 'majorOutageList',
    OUTAGE_EYEBROW: 'outageEyebrow',
    NEWS_LIST: 'newsList',
    CLEAR_FILTER: 'clearFilter',
    EYEBROW_FILTERING_BY: 'eyeBrowFilteringBy',
    VIEW_COUNT_TOOL_TIP: 'viewCountTooltip',
    PUBLISHED_DATE: 'publishedDate',
    SHOWING_SUMMARY_ON_HOMEPAGE: 'showingSummaryOnHomepage',
    VIEW_COUNT_SHORT_NUMBER: 'viewCountShortNumber',
    VIEW_COUNT_SHORT_NUMBER_SPACING: 'viewCountShortNumberSpacing',
    KNOWLEDGE_KEY: "knowledge",
    KB_TOP: 'KB_TOP',
    KNOWLEDGE_CONFIG: {
      KEY: 'KNOWLEDGE_PERMISSION',
      LABEL: 'PERMISSION_CONFIG',
    },
    KNOWLEDGE_CONFIG_ABO: {
      KEY: 'KNOWLEDGE_PERMISSION_ABO',
      LABEL: 'PERMISSION_CONFIG',
    },
  },
  MARKETPLACE_FEATURES: {
    ORDER_SOFTWARE: 'orderSoftware',
  },
  NAV_MENU: {
    KEY: 'UPTIME_NAV_MENU',
    LABEL: 'NAV_MENU_CONFIG',
  },
  NAV_MENU_ABO: {
    KEY: 'UPTIME_NAV_MENU_ABO',
    LABEL: 'NAV_MENU_CONFIG',
  },
  REQUEST_TYPE: {
    BTN_APPROVE: 'btnApprove',
    BTN_REJECT: 'btnReject',
    BTN_RESOLVE: 'btnResolve',
    BTN_REOPEN: 'btnReopen',
    REQUESTS_UPLOAD: 'requestsUpload',
    REQUESTS_COMMENTS: 'requestsComments',
    APPROVAL_UPLOAD: 'approvalUpload',
    APPROVAL_COMMENT: 'approvalComment',
    APPROVER_COMMENT: 'approverComment',
    INCIDENT_UPLOAD: 'incidentUpload',
    INCIDENT_COMMENT: 'incidentComment',
  },
  NOTIFICATION: {
    KEY: 'UPTIME_NOTIFICATION_CONFIG',
    LABEL: 'UPTIME_NOTIFICATION_CONFIG',
    TYPE: {
      DELEGATE_SUBMIT: 'DELEGATE_SUBMIT',
      DELEGATE_ENABLED: 'DELEGATE_ENABLED',
      KNOWLEDGE_COMMENT_RATING: 'KNOWLEDGE_COMMENT_RATING',
      KNOWLEDGE_COMMENT_RESPONSE: 'KNOWLEDGE_COMMENT_RESPONSE',
      KNOWLEDGE_COMMENT_REPLY: 'KNOWLEDGE_COMMENT_REPLY',
    },
  },
  USER_IN_GROUP: {
    DEVICE_MANAGERS: 'deviceManagers',
    ACTIONS_DEVICE_DETAIL: 'actionsOfDeviceDetail',
    MY_TEAM_CARD: 'myTeamCard'
  },
  MANAGERS_PERMISSION: {
    KEY: 'MANAGERS_PERMISSION',
    LABEL: 'PERMISSION_CONFIG',
  },
  MARKETPLACE: {
    KEY: 'MARKETPLACE_PERMISSION',
    LABEL: 'PERMISSION_CONFIG',
  },
  MARKETPLACE_THEME: {
    KEY: 'MARKETPLACE_THEME',
    LABEL: 'MARKETPLACE_THEME',
  },
  UPTIME_STATIC_IMAGE: {
    KEY: 'UPTIME_STATIC_IMAGE',
    LABEL: 'UPTIME_STATIC_IMAGE',
  },
  DYNAMIC_FORM_DESCRIPTIONS: {
    KEY: 'PCL_DYNAMIC_FORM_DESCRIPTIONS',
    LABEL: 'PCL_VERBIAGE_CONFIG',
  },
  PC_ORDER_PAGE_DESCRIPTIONS: {
    KEY: 'PC_ORDER_PAGE_DESCRIPTIONS',
    LABEL: 'PCL_VERBIAGE_CONFIG',
  },
  PC_RETURN_PAGE_DESCRIPTIONS: {
    KEY: 'PC_RETURN_PAGE_DESCRIPTIONS',
    LABEL: 'PCL_VERBIAGE_CONFIG',
  },
  PC_REPORT_BROKEN_PAGE_DESCRIPTIONS: {
    KEY: 'PC_REPORT_BROKEN_PAGE_DESCRIPTIONS',
    LABEL: 'PCL_VERBIAGE_CONFIG',
  },
  PC_LOST_STOLEN_PAGE_DESCRIPTIONS: {
    KEY: 'PC_LOST_STOLEN_PAGE_DESCRIPTIONS',
    LABEL: 'PCL_VERBIAGE_CONFIG',
  },
  PC_REFRESH_PAGE_DESCRIPTIONS: {
    KEY: 'PC_REFRESH_PAGE_DESCRIPTIONS',
    LABEL: 'PCL_VERBIAGE_CONFIG',
  },
  PC_DONT_HAVE_DEVICE_PAGE_DESCRIPTIONS: {
    KEY: 'PC_DONT_HAVE_DEVICE_PAGE_DESCRIPTIONS',
    LABEL: 'PCL_VERBIAGE_CONFIG',
  },
  PC_REGISTER_DEVICE_PAGE_DESCRIPTIONS: {
    KEY: 'PC_REGISTER_DEVICE_PAGE_DESCRIPTIONS',
    LABEL: 'PCL_VERBIAGE_CONFIG',
  },
  PC_RETURN_UNKNOWN_DEVICE_PAGE_DESCRIPTIONS: {
    KEY: 'PC_RETURN_UNKNOWN_DEVICE_PAGE_DESCRIPTIONS',
    LABEL: 'PCL_VERBIAGE_CONFIG',
  },
  UPTIME_GENERAL: {
    KEY: 'UPTIME_GENERAL',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  DELEGATION_APPROVAL_DIALOG_DESCRIPTION: {
    KEY: 'DELEGATION_APPROVAL_DIALOG_DESCRIPTION',
    LABEL: 'DELEGATION_APPROVAL_DIALOG_CONFIG',
  },
  UPTIME_NEW_JOINER_PAGE_CONFIG: {
    KEY: 'UPTIME_NEW_JOINER_PAGE_CONFIG',
    LABEL: 'UPTIME_NEW_JOINER_PAGE_CONFIG',
  },
  INITIAL_NEW_JOINER: {
    KEY: 'DEMO_INITIAL_NEW_JOINER',
    LABEL: 'DEMO_INITIAL_NEW_JOINER',
  },
  NAV_NEW_JOINER_MENU: {
    KEY: 'UPTIME_NEW_JOINER_MENU',
    LABEL: 'UPTIME_NEW_JOINER_MENU',
  },
  UPTIME_DASHBOARD: {
    KEY: 'UPTIME_DASHBOARD_CONFIG',
    LABEL: 'UPTIME_DASHBOARD_CONFIG',
  },
  UPTIME_PRODUCTIVITY: {
    KEY: 'DEMO_UPTIME_PRODUCTIVITY',
    LABEL: 'DEMO_UPTIME_PRODUCTIVITY',
  },
  OUTAGE_CONTENT: {
    KEY: 'UPTIME_OUTAGE_CONTENT',
    LABEL: 'UPTIME_STATIC_PAGE_CONFIG',
  },
  UPTIME_DYNAMIC_ALIGN_CENTER: {
    KEY: "UPTIME_DYNAMIC_ALIGN_CENTER",
    LABEL: "UPTIME_DYNAMIC_ALIGN_CENTER_CONFIG"
  },
  UPTIME_FONT_SETTING: {
    KEY: 'UPTIME_FONT_SETTING',
    LABEL: 'UPTIME_FONT_SETTING_CONFIG',
  },
  UPTIME_QUICK_LINK: {
    KEY: 'UPTIME_QUICK_LINK',
    LABEL: 'UPTIME_QUICK_LINK_CONFIG',
  },
  UPTIME_TEAMS_APP: {
    KEY: 'UPTIME_TEAMS_APP',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  UPTIME_APIM_SERVICES: {
    KEY: 'UPTIME_APIM_SERVICES',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  UPTIME_PERFORMANCE: {
    KEY: 'UPTIME_PERFORMANCE',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  UPTIME_LANGUAGE: {
    KEY: 'UPTIME_LANGUAGE',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  UPTIME_FOOTER: {
    KEY: 'UPTIME_FOOTER',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  UPTIME_QUALTRICS: {
    KEY: 'UPTIME_QUALTRICS',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  UPTIME_ATTACHMENTS: {
    KEY: 'UPTIME_ATTACHMENTS',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  UPTIME_IMAGE: {
    KEY: 'UPTIME_IMAGE',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  UPTIME_KNOWLEDGE: {
    KEY: 'UPTIME_KNOWLEDGE',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  UPTIME_CHAT_WIDGET: {
    KEY: 'UPTIME_CHAT_WIDGET',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  UPTIME_TOOLTIP: {
    KEY: 'UPTIME_TOOLTIP',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  UPTIME_APPLICATION_INSIGHTS: {
    KEY: 'UPTIME_APPLICATION_INSIGHTS',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  UPTIME_HOMEPAGE: {
    KEY: 'UPTIME_HOMEPAGE',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
  UPTIME_STATIC_LANDING_PAGE: {
    KEY: 'UPTIME_STATIC_LANDING_PAGE',
    LABEL: 'UPTIME_STATIC_PAGE_CONFIG'
  },
  UPTIME_GLOBAL_SEARCH_SETTING: {
    KEY: 'UPTIME_GLOBAL_SEARCH_SETTING',
    LABEL: 'UPTIME_GENERAL_CONFIG',
  },
};
